module.exports = __webpack_public_path__ + "static/img/4_IMG_20151228_134332.9df7c386.jpg";